// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__4S_gf","selects":"Documents_selects__1Um1m"};